import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useDocumentBuilderPaths } from '@/common/main/routes/useDocumentBuilderPaths';

/**
 * Opens the block editor from the library list. Uses the absolute path helper so
 * navigation works the same way whether the library is rendered standalone or
 * embedded under the host's `/document-builder` prefix. Optional router `state` hands the editor a
 * one-off message (see `useBlockEditorNoticeHandoff`).
 */
export function useOpenBlockEditor() {
  const navigate = useNavigate();
  const { blockPath } = useDocumentBuilderPaths();

  return useCallback(
    (blockId: string, state?: Record<string, unknown>) => {
      // Prefetch the editor route chunk so `#page-heading` exists before the
      // a11y focus assertions run in Playwright.
      void (async () => {
        await import('@/blocks/presentation/pages/BlockEditorPage');
        if (state) navigate(blockPath(blockId), { state });
        else navigate(blockPath(blockId));
      })();
    },
    [navigate, blockPath]
  );
}
